var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-picker" },
    [
      _c("supsis-table", {
        staticClass: "users-supsis-table",
        attrs: {
          columns: _vm.cols,
          rows: _vm.users,
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("a-input-search", {
                          staticClass: "search-input",
                          attrs: {
                            value: _vm.searchText,
                            placeholder: _vm.$t("message.search"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.searchTextHandle($event)
                            },
                            search: _vm.onSearch,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }